<template>
  <transition name="toast">
    <div v-if="show && config" v-tap class="toast" @touchmove.prevent>
      <div v-if="config.type === 'loading'" class="toast-mask-loading">
        <div class="toast-mask-loading-icon"></div>
        <div class="toast-mask-loading-text">
          {{ config.text }}
        </div>
      </div>
      <div v-if="config.type === 'text'" class="toast-mask-text">
        <div>{{ config.text }}</div>
      </div>
      <div v-if="config.type === 'pay'" class="toast-pay">
        <div class="toast-pay-icon"></div>
        <div class="toast-pay-text">{{ config.text }}</div>
        <div class="toast-pay-dot">
          <div
            v-for="(item, index) in Array(3)"
            :key="index"
            ref="dot"
            class="toast-pay-dot-item"
          ></div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Toast',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentDotIndex: 0,
      dotTimer: null,
      dotNodeList: null,
    }
  },
  computed: {},
  watch: {
    config: function() {
      if (this.config.type === 'pay') {
        if (this.dotTimer) {
          clearInterval(this.dotTimer)
          this.currentDotIndex = 0
          this.dotNodeList = null
        }
        this.dotTimer = window.setInterval(() => {
          if (!this.dotNodeList) {
            this.dotNodeList = document.querySelectorAll('.toast-pay-dot-item')
          }
          this.dotNodeList.forEach((p, index) => {
            if (this.currentDotIndex === index) {
              p.classList.add('highlight')
            } else {
              p.classList.remove('highlight')
            }
          })
          if (this.currentDotIndex === this.dotNodeList.length - 1) {
            this.currentDotIndex = 0
          } else {
            this.currentDotIndex++
          }
        }, 300)
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.dotTimer)
  },
  methods: {},
}
</script>
<style lang="less">
@import '../../assets/variable.less';
.toast {
  &-enter-active {
    animation: fade-in both 0.2s;
  }
  &-leave-active {
    animation: fade-out both 0.2s;
  }
  .flex-center(center);
  .size(100%);
  top: 0;
  left: 0;
  position: fixed;
  z-index: 102;
  background-color: transparent;
  &-mask-loading {
    .flex-column-center();
    .size(100%);
    border-radius: 2px;
    background-color: rgba(0, 0, 0, 0.75);
    padding-top: 20px;
    padding-bottom: 16.5px;
    &-icon {
      .bg-img(url('../../assets/img/loading.png'));
      .size(32px);
      margin-bottom: 6.5px;
      animation: rotate 1s linear infinite;
    }
    &-text {
      color: #ffffff;
    }
  }
  &-mask-text {
    .flex-center(center);
    color: #ffffff;
    padding: 12px;
    min-height: 40px;
    max-width: 300px;
    text-align: center;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.75);
  }
  &-pay {
    .flex-column-center();
    .size(130px);
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 12px;
    &-icon {
      .size(40px);
      .bg-img(url('../../assets/img/pay-loading.png'));
      margin-top: 22px;
    }
    &-text {
      margin-top: 9px;
      font-family: PingFangSC-Semibold;
      .font-area(16px);
      color: #ffffff;
      text-align: center;
    }
    &-dot {
      .flex-center(space-between);
      margin-top: 15px;
      height: 6px;
      width: 100%;
      padding: 0 44px;
      &-item {
        .size(6px);
        background: #ffffff;
        border-radius: 6px;
        opacity: 0.2;
      }
    }
  }
}
.highlight {
  opacity: 1;
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>
